<template>
  <GenericModuleForm
    :title="title"
    :model-value="state.isActive"
    :loading="isLoading"
    :response-message="state.response.message"
    :response-type="state.response.type"
    :help-center-key="helpKey"
    :description="description"
    @toggle="toggleRetainExtraPasses"
    @dismiss-response="resetResponse"
  />
</template>

<script>
import useConfirmation from "@/composables/useConfirmation"
import retainExtraPassesConstants from "@/constants/retainExtraPassesConstants"
import GenericModuleForm from "@/v3components/Forms/ModuleListForms/GenericModuleForm.vue"
import { computed, inject, onMounted, reactive, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "RetainExtraPassesModuleForm",
  components: {
    GenericModuleForm
  },
  setup() {
    const store = useStore()
    const modal = inject("modal")
    const isLoading = ref(false)

    const state = reactive({
      response: {
        type: "",
        message: "",
        errors: {}
      },
      isActive: false
    })

    const isRetainExtraPassesActive = computed(() => {
      const activeSchoolModules =
        store?.state?.schools?.activeSchoolModules || []
      const index = activeSchoolModules.findIndex(
        (module) => module?.name === retainExtraPassesConstants.MODULE
      )
      return index !== -1
        ? Boolean(
            store?.state?.schools?.activeSchoolModules?.[index]?.pivot?.status
          )
        : false
    })

    const resetResponse = () => {
      state.response = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.response = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.response = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }

    const toggleRetainExtraPasses = async (status) => {
      if (isLoading.value) return

      if (state.isActive && !status) {
        const { showConfirmation } = useConfirmation(modal)
        const confirmed = await showConfirmation({
          heading: "Please confirm",
          headingIcon: "ri ri-alert-line",
          headingColor: "red",
          headerPlacement: "start",
          body: `Are you sure you want to disable the "${retainExtraPassesConstants.MODULE}" module?`,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonSolid: false,
          buttonPlacement: "end"
        })

        if (!confirmed) {
          return
        }
      }

      isLoading.value = true
      try {
        resetResponse()
        await store.dispatch("modules/updateRetainExtraPasses", {
          retainExtraPasses: status
        })
        state.isActive = status
        await store.dispatch("schools/getActiveModules", {
          clearCacheEntry: true
        })
        setSuccessResponse("Module updated.")
      } catch (error) {
        const response = error.response ? error.response.data : {}
        setErrorResponse(response.message, response.errors)
      } finally {
        isLoading.value = false
      }
    }

    onMounted(() => {
      state.isActive = isRetainExtraPassesActive.value
    })

    return {
      isLoading,
      title: retainExtraPassesConstants.MODULE,
      helpKey: retainExtraPassesConstants.RETAIN_EXTRA_PASSES_HELP_KEY,
      description: retainExtraPassesConstants.MODULE_DESCRIPTION,
      state,
      toggleRetainExtraPasses,
      resetResponse
    }
  }
}
</script>
